<template>
  <div class="page-content-wrapper">
    <div class="page-content lock-page">
      <!-- BEGIN PAGE HEADER-->
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <i class="fa fa-home"></i>
            <a href="index.html">首页</a>
            <i class="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">iKey设备</a>
          </li>
        </ul>
      </div>
      <!-- END PAGE HEADER-->
      <div>
        <div id="search-bar">
          <select id="community_select2" class="form-control select2 select2-allowclear">
            <option  v-for="item in communities" :value="item.id">{{item.description}}</option>
          </select>
          <input
            style="margin-left: 3px;"
            type="text"
            placeholder="输入设备描述"
            class="form-control search-bar-item"
            name="desc"
            v-model="biz.desc"
            id="desc"
          />
          <input
            type="text"
            placeholder="输入设备MAC"
            class="form-control search-bar-item"
            name="mac"
            v-model="biz.mac"
            id="mac"
          />
          <button type="button" class="btn blue" @click="search">
            查询
            <i class="fa fa-search"></i>
          </button>
          <button v-if="auth('biz_lock_file')" type="button" class="btn blue" @click="imp">
            导入设备
            <i class="fa fa-upload"></i>
          </button>
          <button v-if="auth('biz_lock_del')" type="button" class="btn red" @click="remove">
            删除
            <i class="fa fa-remove"></i>
          </button>
        </div>
      </div>

      <table class="table table-striped table-hover table-bordered table-condensed">
        <thead>
          <tr>
             <th width="6%">
            <input type="checkbox" name="check-title" @change="changeCheckbox($event,0,0)" id="check-all"> 全选
            </th>
            <th width="13%" class="text_overflow">MAC</th>
            <th width="25%" class="text_overflow mh">描述</th>
            <th width="25%" class="text_overflow mh">安装位置</th>
            <th width="15%" class="text_overflow mh">安装时间</th>
            <!-- <th width="5%" class="text_overflow mh"></th> -->
            <th width="10%">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in locks" v-bind:key="item.id">
             <td style="text-align:center">
            <input type="checkbox" name="check-item" @change="changeCheckbox($event,1,item.id)" :id="item.id">
            </td>
            <td style="vertical-align:middle; text-align:center" class="text_overflow">{{item.mac}}</td>
            <td style="vertical-align:middle" class="text_overflow mh">{{item.desc}}</td>
            <td style="vertical-align:middle; text-align:center" class="text_overflow mh">
              <!-- {{addrLabel}} -->
              <span>{{addrLabel(item.addrs)}}</span>
            </td>
            <td
              style="vertical-align:middle; text-align:center"
              class="text_overflow mh"
            >{{item.create_time}}</td>
            <td style="text-align:center">
              <a v-if="auth('biz_lock_detail')" href="javascript:;" @click="detail(item.id)">详情</a>
              <a v-if="auth('biz_lock_del')" href="javascript:;" @click="remove(item.id, $event)">删除</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="pager-bar">
        <pager
          :page-index="pageIndex"
          :page-size="pageSize"
          :total-count="totalCount"
          :action="query"
          @page-change="onPageChange"
        ></pager>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../lib/utils/request.js'
// import fileutil from '../lib/utils/fileutil.js'
import commonMethods from '../lib/methods/common.js'
import Pager from './fragment/Pager.vue'
import LockDetail from './LockDetail.vue'
import UploadPannel from './UploadPannel.vue'
import BootstrapModal from './fragment/BootstrapModal.vue'
import { MSG_ID, K_LOGINED_USER } from '../lib/constant'
import { mapState } from 'vuex'
import mixins from '../mixins'
import mixinTableCheckbox from '../mixins/table-checkbox.js'
import db from '../store/local'

export default {
  mixins: [...mixins, mixinTableCheckbox],
  name: 'lock',
  data () {
    return {
      locks: [],
      // 列表分页用数据
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      biz: {
        mac: '',
        desc: ''
      },
      communities: []
    }
  },
  components: {
    LockDetail,
    UploadPannel,
    BootstrapModal,
    Pager
  },
  created () {
  },
  mounted () {
    // 注册事件
    window.emitter.on(MSG_ID.MSG_LOCK_REFRESH, (...args) => {
      this.query()
    })
    this.communities = db.get(K_LOGINED_USER).account.communities
    window.$('#community_select2').select2({
      allowClear: false
    })
    this.fill()
    this.query()
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      this.uncheckAll()
      this.resetPager()
      this.query()
    },
    fill () {
      let reqdata = { parent_addr_id: '0', page_index: 1, page_size: 500 }
      http.invoke('addr.pageAddr', reqdata, (data0) => {
        this.level1Addrs = data0.content
        // 等待渲染完成后，填充select2
        setTimeout(() => {
          window.$('#community_select2').select2('val', this.communities[0].id)
        }, 100)
      })
    },
    query () {
      this.uncheckAll()
      let cid = window.$('#community_select2').select2('val')
      let reqdata = {
        mac: this.biz.mac,
        desc: this.biz.desc,
        uid: db.get(K_LOGINED_USER).account.id,
        community_id: cid,
        page_index: this.pager.pageIndex,
        page_size: this.pageSize
      }
      http.post('lock.pageLock', reqdata, { session: this.session() }, (data) => {
        this.locks = data.content
        this.totalCount = data.total_count
      }, (res) => {
        console.log(res)
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, LockDetail, { title: '设备详情页', id: id })
    },
    imp (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, UploadPannel, { title: '设备数据导入', url: '/lock/upload' })
    },
    remove (id, el) {
      if (+id > 0 || this.willRemoved.size > 0) {
        window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除门禁信息', () => {
          let reqdata = { ids: (+id > 0 ? [id] : [...this.willRemoved]) }
          http.post('lock.remove', reqdata, {}, this.query, () => { })
        })
      } else {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '请选中需要删除的数据')
      }
    },
    addrLabel (addrs) {
      console.log(addrs)
      if (!addrs) {
        return ''
      }
      let lables = []
      for (let addr of addrs) {
        lables.push(addr.description)
      }
      return lables.join('-')
    },
    ...commonMethods
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lock-page {
  background-color: #fff;
}
#search-bar {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#pager-bar {
  text-align: center;
}
.search-bar-item {
  flex-grow: 1;
  margin-right: 3px;
}
.table th {
  text-align: center;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Lock.vue?39414808